import clsx from 'clsx';
import type { FC } from 'react';
import type { RadioOptionProps } from '../../types';

const RadioOption: FC<RadioOptionProps> = ({
  id,
  name,
  value,
  checked,
  disabled = false,
  labelClassName = 'personal-meetings-modal__radio-label',
  showBadge = false,
  badgeText = 'PAID FEATURE',
  onChange,
  children,
}) => (
  <>
    <div
      className={clsx('personal-meetings-modal__radio-option', {
        'personal-meetings-modal__radio-option--disabled': disabled,
      })}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        className="personal-meetings-modal__radio-input"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id} className={labelClassName}>
        {children}
      </label>
    </div>
    {showBadge && <span className="personal-meetings-modal__paid-badge">{badgeText}</span>}
  </>
);

export default RadioOption;
